module.exports = __webpack_public_path__ + "static/media/hero-small.3dfb0a85.png";